import { render, staticRenderFns } from "./InLearningFormularioVentas.vue?vue&type=template&id=296cae1e&"
import script from "./InLearningFormularioVentas.vue?vue&type=script&lang=js&"
export * from "./InLearningFormularioVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports